import CallLogWithDurationPagingResultModelBase from '../_generated/modelBases/call-log-with-duration-paging-result-model-base';

export default class CallLogWithDurationPagingResultModel extends CallLogWithDurationPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
